import React, { useEffect, useState } from "react";
import MyPresetManager from "./MyPresetManager.js";
import GoogleSignIn from "./MyPresetUtils/GoogleSignIn.js";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const MyPresetAuthManager = (props) => {
  const [showWelcome, setShowWelcome] = useState(false);

  const getFirstName = (name) => {
    if (!name) return "there";
    return name.split(" ")[0];
  };

  useEffect(() => {
    if (!showWelcome) return undefined;

    const timer = setTimeout(() => setShowWelcome(false), 1800);
    return () => clearTimeout(timer);
  }, [showWelcome]);

  return (
    <div className="my-presets-auth">
      {props?.user && showWelcome ? (
        <section className="my-presets-welcome">
          <span className="my-presets-welcome-icon">
            <CheckCircleRoundedIcon />
          </span>
          <h2>Welcome back, {getFirstName(props.user?.displayName)}</h2>
        </section>
      ) : props?.user ? (
        <>
          <MyPresetManager
            key={props.user.uid}
            user={props.user}
            addTasksToList={props.addTasksToList}
            onSignOut={() => props.setUser(null)}
            setIsMenuOn={props.setIsMenuOn}
            tasks={props.tasks}
            onFlowChange={props.onFlowChange}
          ></MyPresetManager>
        </>
      ) : (
        <GoogleSignIn
          onSignIn={(loggedInUser, options = {}) => {
            props.setUser(loggedInUser);
            setShowWelcome(Boolean(options.showWelcome));
          }}
        />
      )}
    </div>
  );
};

export default MyPresetAuthManager;
